<template>
  <div class="home">
    <ProductSummaryList :scroll="corY" ref="refreshList" />
  </div>
</template>

<script>
import ProductSummaryList from '@/components/product/ProductSummaryList.vue'

export default {
  name: 'ProductSummary',
  components: {
    ProductSummaryList
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      productCategory: [],
      vendors: [],
      product: {
        id: null,
        product_no: null,
        product_name: null,
        product_description: null,
        barcode: null,
        uom_id: null,
        category_id: null,
        price: null,
        cost: null,
        costing_method: null,
        costing_evaluation: null,
        active: null,
        type_id: null,
        canBarcode: null,
        total_purchasing: null,
        total_onHand: null,
        total_sales: null,
        total_workshop: null,
        total: null,
        total_round: '0',
        total_round_uom: null,
        total_decimal: '0',
        total_decimal_uom: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.product = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.product = {
        id: null,
        product_no: null,
        product_name: null,
        product_description: null,
        barcode: null,
        uom_id: null,
        category_id: null,
        price: null,
        cost: null,
        costing_method: null,
        costing_evaluation: null,
        active: null,
        type_id: null,
        canBarcode: null,
        total_purchasing: null,
        total_onHand: null,
        total_sales: null,
        total_workshop: null,
        total: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.product = {
        id: null,
        product_no: null,
        product_name: null,
        product_description: null,
        barcode: null,
        uom_id: null,
        category_id: null,
        price: null,
        cost: null,
        costing_method: null,
        costing_evaluation: null,
        active: null,
        type_id: null,
        canBarcode: null,
        total_purchasing: null,
        total_onHand: null,
        total_sales: null,
        total_workshop: null,
        total: null,
        total_round: '0',
        total_round_uom: null,
        total_decimal: '0',
        total_decimal_uom: null
      }
      this.$refs.refreshList.refreshProduct()
    }
  },
  mounted () {
    this.$store.dispatch('getProductUomList')
    this.$store.dispatch('getProductCategoryList')
    this.$store.dispatch('getVendorList')
    this.$store.dispatch('getPriceListGroup')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getCompanyList')
  }
}
</script>
